/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';
import { MED_DATETIME_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { SelectOption, SilentSelectField } from '@coursera/cds-core';

import type { SubmissionHeader } from 'bundles/grading/api/types';

import _t from 'i18n!nls/grading';

type Props = {
  onChange: (value: string) => void;
  submissionHeaders: SubmissionHeader[];
  selectedAttemptId: string;
};

const formatSubmissionDate = (submissionDateSeconds: string) => {
  const submissionDateMillis = parseInt(submissionDateSeconds, 10) * 1000;
  return formatDateTimeDisplay(submissionDateMillis, MED_DATETIME_DISPLAY);
};

const AttemptSelector = ({ onChange, submissionHeaders, selectedAttemptId }: Props) => {
  const handleOnChange = (event: React.ChangeEvent<{ value: unknown }>) => onChange(event.target.value as string);

  return (
    <SilentSelectField
      label={_t('Select submission attempt')}
      labelPlacement="none"
      value={selectedAttemptId}
      onChange={handleOnChange}
    >
      {submissionHeaders.map((submissionHeader, index) => {
        const submissionDateSeconds = submissionHeader.submittedAt?.seconds;

        return (
          <SelectOption key={submissionHeader.submissionAttemptId} value={submissionHeader.submissionAttemptId}>
            <strong>
              <FormattedMessage
                message={_t('Attempt {attemptNumber}: ')}
                attemptNumber={submissionHeader.attemptNumber}
              />
            </strong>
            {submissionDateSeconds && formatSubmissionDate(submissionDateSeconds)}
            {index === 0 && _t(' (latest)')}
          </SelectOption>
        );
      })}
    </SilentSelectField>
  );
};

export default AttemptSelector;
